// extracted by mini-css-extract-plugin
module.exports =  {"header":"ccfda6eb9f--header--llig8"};